<script setup lang="ts">
  defineProps<{
    error: boolean;
    errorText: string;
  }>();
</script>

<template>
  <v-col
    cols="12"
    sm="6"
  >
    <div class="d-flex justify-start gap-2 align-start">
      <v-icon
        :color="error ? 'error' : 'success'"
        size="20"
        :icon="error ? 'mdi-close-circle' : 'mdi-check-circle'"
      >
      </v-icon>
      <p class="text-caption">{{ errorText }}</p>
    </div>
  </v-col>
</template>
